export const ACCUCLAIM_EDIT_LOADING = 'ACCUCLAIM_EDIT_REPORT_LOADING';
export const ACCUCLAIM_EDIT_LOAD_ERROR = 'ACCUCLAIM_EDIT_REPORT_LOAD_ERROR';
export const ACCUCLAIM_EDIT_GET_REPORT = 'ACCUCLAIM_EDIT_REPORT_GET_REPORT';
export const ACCUCLAIM_EDIT_SET_SELECTED_SITES =
  'ACCUCLAIM_EDIT_REPORT_SET_SITES';



// WEBPACK FOOTER //
// ./src/pages/accuclaimedit/state/report/types.js